export class UserAdd {
    full_name: string;
    contact: string;
    username: string;
    email: string;
    user_type: number;
  }